<form
  name="visaReportsForm"
  novalidate=""
  class="ng-scope ng-pristine ng-invalid ng-invalid-required"
  *ngIf="hasEntitlements('REPORTS_SHIP') || hasEntitlements('REPORTS_SHORE')"
>
  <div class="card card-nc">
    <div class="card-heading">
      <i class="fa fa-bar-chart"></i
      ><span class="cardHeaderHeading"> VISA Reports</span
      ><span class="pull-right globalHeaderUserRole ng-binding"></span>
    </div>
    <div class="card-body">
      <div *ngIf="loading" class="col-1">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
      </div>
      <div class="row" *ngIf="!loading">
        <div
          class="form-group col-md-4"
        >
          <span class="labelCommon">Report Date</span> <br />
          <div class="form-group">
            <div class="input-group">
              <input
                type="text"
                class="form-control reports-date-picker"
                name="dp1"
                [(ngModel)]="startDate"
                [maxDate]="endDate"
                (change)="changedate()"
                ngbDatepicker
                #d1="ngbDatepicker"
                (ngModelChange)="changeDate()"
              />
              <div class="input-group-append">
                <button class="btn-cal input-sm" (click)="d1.toggle()">
                  <i class="fa fa-calendar"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="spinner-wrapper" *ngIf="spinner">
  <div role="status">
    <i class="fa fa-spinner fa-4x fa-pulse"></i>
  </div>
</div>
<div class="row searchResultsRow" *ngIf="transactions.length == 0 && !spinner">
  No reports found
</div>
<div class="searchResults ng-scope" *ngIf="transactions.length > 0 && !spinner">
  <div class="zeroPadding" *ngFor="let transaction of transactions">
    <div
      class="row searchResultsRow"
      (click)=" showShipReportDetails(transaction.fileName)
      "
    >
      <div class="col-md-11">
        <div class="searchResultName">
          <div>{{ transaction.name }}</div>
        </div>
        <div class="searchResultDataName">{{ transaction.nameDesc }}</div>
        <div class="searchResultDataName" style="padding-top: 5px">
          Report Date:
          <span class="searchResultDataVal">{{
            transaction.dateCreated | date : "MM/dd/yyyy"
          }}</span>
          |
          <span class="searchResultDataVal">{{
            transaction.dateCreated | date : "h:mm:ss a"
          }}</span>
          | Report Type:
          <span class="searchResultDataVal">{{
            transaction.fileExtension
          }}</span>
          | Report Name:
          <span class="searchResultDataVal">{{
            removeFileExtension(transaction.fileName)
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
